module.exports = __webpack_public_path__ + "img/STERiGLIDE_02_01.1891d879.jpg";